// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToEndOfChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    ExecuteOnSuccessCallback
} from "@insite/client-framework/Store/CommonHandlers/ShareProduct";
import { getDataLayer } from "@turnerBlueprint/XDL/Utilities/DataLayer";

export const _GATrackShareProduct: typeof ExecuteOnSuccessCallback = props => {
    const dataLayer = getDataLayer();
    
    if(props.apiResult && dataLayer) {
        const googleAnalyticsData = {
            event: "share_product",
            page: window.location.href,
            affiliation: props.parameter.yourName,
            email: props.parameter.yourEmailAddress,
            recipient: props.parameter.friendsEmailAddress,
        };
        dataLayer.push(googleAnalyticsData);
    }
};

addToEndOfChain(chain, _GATrackShareProduct);